import axios from 'axios';
import store from '../../store/index';

export default {
	login(username, password) {
		return axios.post('api/auth/login/', {
			username: username,
			password: password,
		});
	},
	requestPasswordReset(email) {
		return axios.post('api/auth/reset', { email: email, frontend: 'Interface' });
	},
	verifyToken(token) {
		return axios.get(`api/auth/reset?token=${token}`);
	},
	resetPassword(password, token) {
		return axios.patch(`api/auth/reset?token=${token}`, { password: password });
	},
	changePassword(password) {
		return axios.patch(
			`api/admins/me/password`,
			{ password: password },
			{
				headers: {
					Authorization: `Bearer ${store.state.auth.token}`,
				},
			}
		);
	},
	load() {
		return axios.get('/api/sso/', {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
};
